/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';

@Pipe({
  name: 'fromDate',
})
export class FromDatePipe implements PipeTransform {
  transform(value: Date | dayjs.Dayjs): any {
    return dayjs(value).fromNow();
  }
}
